import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-portal-footer',
	templateUrl: './portal-footer.component.html',
	styleUrls: ['./portal-footer.component.css']
})
export class PortalFooterComponent implements OnInit {

	constructor(
		public router: Router,
	) {
	}

	ngOnInit() {
	}

}
